<template>
  <v-list-item
    v-bind="$attrs"
    @click="$emit('itemClicked', item)"
    :class="{ 'readed-notification': item.isRead }"
  >
    <v-list-item-action class="list-item-left-action">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            :disabled="item.isRead"
            @click.stop="$emit('markMessageAsRead', item)"
          >
            <v-icon v-if="item.isRead">mdi-email-open</v-icon>
            <v-icon v-else>mdi-email</v-icon>
          </v-btn>
        </template>
        <span>{{$t('notifications.markSeen')}}</span>
      </v-tooltip>
    </v-list-item-action>

    <v-list-item-content>
      <v-list-item-title v-text="item.sender"></v-list-item-title>
      <v-list-item-subtitle v-text="timeToString(item.date, $i18n.locale)"></v-list-item-subtitle>
      <v-list-item-subtitle v-text="stripHtml(item.message)"></v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-action>
      <v-btn v-if="isInSnackBar" icon @click.stop="$emit('removeFromSnackbar', item)">
        <v-icon>mdi-close-circle</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { convertTimeToString } from '../tools/convertTimeToString'

export default {
  props: ['item', 'isInSnackBar'],
  methods: {
    timeToString: convertTimeToString,
    stripHtml(html) {
      let tmpDiv = document.createElement('div')
      tmpDiv.innerHTML = html
      return tmpDiv.textContent || tmpDiv.innerText || ''
    }
  }
}

</script>

<style lang="scss" scoped>
.list-item-left-action {
  margin-right: 16px !important;
}
.readed-notification {
  opacity: 0.8;
}
</style>